export function validTotals(data, now = Date.now()) {
  if (!data || data.campaign !== 'october-2026' || data.enabled !== true) return false;
  const generated = Date.parse(data.generatedAt);
  return Number.isSafeInteger(data.visits) && data.visits >= 0
    && Number.isSafeInteger(data.shoppers) && data.shoppers >= 0
    && Number.isFinite(generated) && now - generated <= 60000 && generated - now <= 15000;
}
if (typeof window !== 'undefined' && !customElements.get('scentality-activity')) {
  const preview = window.Shopify?.theme?.role !== 'main' && new URLSearchParams(location.search).get('sc_activity_preview') === '1';
  const widgets = new Set();
  let timer, busy = false;
  function hide() { widgets.forEach(el => { if (el.dataset.editor !== 'true') el.hidden = true; }); }
  async function refresh() {
    if (busy || document.hidden) return;
    const active = [...widgets].filter(el => el.dataset.editor !== 'true');
    const source = active.find(el => el.dataset.feed);
    if (!source || (!preview && Date.now() < Date.parse(source.dataset.launch))) { hide(); return; }
    let url;
    try {
      url = new URL(source.dataset.feed, location.origin);
      if (preview) url.searchParams.set('preview','1');
      if (url.protocol !== 'https:' || url.username || url.password) { hide(); return; }
    } catch { hide(); return; }
    busy = true;
    try {
      const response = await fetch(url.href, {credentials:'omit', cache:'no-store', signal:AbortSignal.timeout(8000)});
      if (!response.ok) throw new Error('Feed unavailable');
      const totals = await response.json();
      if (!validTotals(totals)) throw new Error('Invalid or stale totals');
      active.forEach(el => {
        el.querySelector('[data-sc-visits]').textContent = totals.visits.toLocaleString('en-GB');
        el.hidden = false;
      });
    } catch { hide(); } finally { busy = false; }
  }
  customElements.define('scentality-activity', class extends HTMLElement {
    connectedCallback() {
      widgets.add(this);
      if (this.dataset.editor === 'true') return;
      refresh();
      if (!timer) timer = setInterval(refresh, 10000);
    }
    disconnectedCallback() {
      widgets.delete(this);
      if (![...widgets].some(el => el.dataset.editor !== 'true')) { clearInterval(timer); timer = null; }
    }
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
}

